import apiClient from "@toothfairy/shared-api/apiClient";
import secureRequest from "@toothfairy/shared-api/secureAPI";
import AppAuth from "@toothfairy/shared-ui/AppAuthScreen";
import envConfig from "../../../envConfig";

const createSipTrunk = async ({
  name,
  twilio_sid,
  twilio_token,
  phone_numbers,
  workspace_id,
  livekit_url,
  api_key,
  api_secret,
}) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/channels/sip/trunk`;
  const requestBody = {
    name,
    twilio_sid,
    twilio_token,
    workspace_id,
    ...(phone_numbers && { phone_numbers }),
    ...(livekit_url && { livekit_url }),
    ...(api_key && { api_key }),
    ...(api_secret && { api_secret }),
  };
  return secureRequest(
    apiClient.apiClient,
    "POST",
    url,
    null,
    requestBody,
    true,
    null,
    payload
  );
};

const createSipDispatchRule = async ({
  trunk_id,
  phone_number,
  agent_id,
  workspace_id,
  user_id,
  agent_name,
  livekit_url,
  api_key,
  api_secret,
}) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/channels/sip/dispatch`;
  const requestBody = {
    trunk_id,
    phone_number,
    agent_id,
    workspace_id,
    ...(user_id && { user_id }),
    ...(agent_name && { agent_name }),
    ...(livekit_url && { livekit_url }),
    ...(api_key && { api_key }),
    ...(api_secret && { api_secret }),
  };
  return secureRequest(
    apiClient.apiClient,
    "POST",
    url,
    null,
    requestBody,
    true,
    null,
    payload
  );
};

const listSipTrunks = async ({
  workspace_id,
  livekit_url,
  api_key,
  api_secret,
}) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/channels/sip/trunk`;
  const requestBody = {
    workspace_id,
    ...(livekit_url && { livekit_url }),
    ...(api_key && { api_key }),
    ...(api_secret && { api_secret }),
  };
  return secureRequest(
    apiClient.apiClient,
    "GET",
    url,
    null,
    requestBody,
    true,
    null,
    payload
  );
};

const deleteSipTrunk = async ({ trunk_id, phone_number, workspace_id, livekit_url, api_key, api_secret }) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/channels/sip/trunk`;
  const requestBody = {
    workspace_id,
    ...(trunk_id && { trunk_id }),
    ...(phone_number && { phone_number }),
    ...(livekit_url && { livekit_url }),
    ...(api_key && { api_key }),
    ...(api_secret && { api_secret }),
  };
  return secureRequest(
    apiClient.apiClient,
    "DELETE",
    url,
    null,
    requestBody,
    true,
    null,
    payload
  );
};

const listSipDispatchRules = async ({
  workspace_id,
  livekit_url,
  api_key,
  api_secret,
}) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/channels/sip/dispatch`;
  const requestBody = {
    workspace_id,
    ...(livekit_url && { livekit_url }),
    ...(api_key && { api_key }),
    ...(api_secret && { api_secret }),
  };
  return secureRequest(
    apiClient.apiClient,
    "GET",
    url,
    null,
    requestBody,
    true,
    null,
    payload
  );
};

const deleteSipDispatchRule = async ({ rule_id, workspace_id, livekit_url, api_key, api_secret }) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/channels/sip/dispatch`;
  const requestBody = {
    rule_id,
    workspace_id,
    ...(livekit_url && { livekit_url }),
    ...(api_key && { api_key }),
    ...(api_secret && { api_secret }),
  };
  return secureRequest(
    apiClient.apiClient,
    "DELETE",
    url,
    null,
    requestBody,
    true,
    null,
    payload
  );
};

const createSipOutboundTrunk = async ({
  workspace_id,
  twilio_sid,
  twilio_token,
  phone_number,
  livekit_url,
  api_key,
  api_secret,
}) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/channels/sip/outbound`;
  const requestBody = {
    workspace_id,
    twilio_sid,
    twilio_token,
    phone_number,
    ...(livekit_url && { livekit_url }),
    ...(api_key && { api_key }),
    ...(api_secret && { api_secret }),
  };
  return secureRequest(
    apiClient.apiClient,
    "POST",
    url,
    null,
    requestBody,
    true,
    null,
    payload
  );
};

const getSipConfig = async ({
  workspace_id,
  livekit_url,
  api_key,
  api_secret,
}) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/channels/sip/config`;
  const requestBody = {
    workspace_id,
    ...(livekit_url && { livekit_url }),
    ...(api_key && { api_key }),
    ...(api_secret && { api_secret }),
  };
  return secureRequest(
    apiClient.apiClient,
    "POST",
    url,
    null,
    requestBody,
    true,
    null,
    payload
  );
};

const createSipOutboundTrunkForAgent = async ({
  workspace_id,
  phone_number,
  twilio_sid,
  channel_id,
}) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/channels/sip/outbound/agent`;
  const requestBody = {
    workspace_id,
    phone_number,
    twilio_sid,
    channel_id,
  };
  return secureRequest(
    apiClient.apiClient,
    "POST",
    url,
    null,
    requestBody,
    true,
    null,
    payload
  );
};

const deleteSipOutboundTrunkForAgent = async ({ workspace_id }) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/channels/sip/outbound/agent`;
  const requestBody = {
    workspace_id,
  };
  return secureRequest(
    apiClient.apiClient,
    "DELETE",
    url,
    null,
    requestBody,
    true,
    null,
    payload
  );
};

export default {
  createSipTrunk,
  createSipDispatchRule,
  listSipTrunks,
  deleteSipTrunk,
  listSipDispatchRules,
  deleteSipDispatchRule,
  createSipOutboundTrunk,
  getSipConfig,
  createSipOutboundTrunkForAgent,
  deleteSipOutboundTrunkForAgent,
};